<div #imageContainer>
  @if (showImage) {
    <img
      #markerImage
      [width]="imageWidth"
      [height]="imageHeight"
      [src]="imageSrc"
      [alt]="imageAlt"
    />
  }
</div>
<div #container></div>
